export default __webpack_public_path__ + "static/media/sto-tiered-usd.742fc579.svg";